<template>
  <el-drawer ref="drawer" class="m-drawer" title="抖音店铺发布信息确认" :visible.sync="drawerVisible" @close="handleClose" size="1100px">
    <div class="drawer-content">
      <el-container>
        <el-aside width="260px" class="left-aside">
          <h3 class="title">款式编码</h3>
          <div class="search-row">
            <el-input style="width: 160px" v-model="searchTxt" @keyup.enter.native="searchClick"></el-input>
            <el-button type="primary" @click="searchClick">搜索</el-button>
          </div>
          <el-menu :default-active="baseItemId" class="el-menu-vertical" @select="selectMenu">
            <el-menu-item v-for="item in list" :key="item.baseItemId" :index="item.baseItemId">
              <span slot="title" class="slot-title">
                <p>{{ item.outerId }}</p>
                <p class="title">
                  <span>{{ item.title }}</span>
                </p>
                <span v-if="noFinsheds[item.baseItemId].length" class="wraning-wrap el-icon-warning"></span>
              </span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container v-show="shopId">
          <el-main class="right-main">
            <el-tabs v-model="shopId" @tab-click="changeShopTab">
              <el-tab-pane v-for="shop in checkResultList" :key="shop.shopId" :label="shop.shopName" :name="shop.shopId">
                <span slot="label">
                  <el-image style="width: 16px; height: 16px; margin-right: 5px; top: 4px" :src="ddianImg"></el-image>{{ shop.shopName }}
                  <i
                    v-if="(noFinsheds[shop.baseItemId] || []).includes(shop.shopId)"
                    style="color: #f56c6c; font-size: 14px"
                    class="el-icon-warning"
                  ></i>
                </span>
              </el-tab-pane>
            </el-tabs>
            <div class="form-content">
              <add-size ref="addSizeRef" :hideShopSelect="true" :templateList="formData.sizeInfo" :checkSize="true" :categoryId="categoryId" :componentTemplateRule="componentTemplateRule"/>
              <el-form ref="form" v-if="shopId" :model="formData" label-width="110px" :rules="rules" style="margin-top: 10px">
                <el-form-item label="发货模式:" prop="presellType">
                  <el-radio-group v-model="formData.presellType" class="delivery">
                    <el-radio v-for="item in deliveryModes" :label="item.value" :value="item.value" :key="item.value" :disabled="!item.support && !item.newSupport" style="margin-right: 20px;">
                      {{ item.label }} <span v-if="!item.support && !item.newSupport" style="color: red;">（该店铺不支持此模式）</span>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="现货发货时间:" v-if="formData.presellType === 0 || formData.presellType === 2" prop="deliveryDelayDay">
                    <div class="delivery-time">
                        <!-- 新现货+预售发货模式使用checkbox -->
                        <el-checkbox-group @change="handleDeliveryDelayDayChange" v-if="formData.presellType === 2 && timeSkuPresellWithNormalRule.support" v-model="formData.deliveryDelayDay" class="deliveryDelayDay">
                            <el-checkbox v-for="item in normalDelayOptions" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
                        </el-checkbox-group>
                        <!-- 现货发货模式使用radio -->
                        <el-radio-group v-else v-model="formData.deliveryDelayDay" class="deliveryDelayDay">
                            <el-radio v-for="item in normalDelayOptions" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </div>
                </el-form-item>
                <el-form-item label="预售发货时间:" v-if="formData.presellType === 2" prop="timeSpecList">
                  <div class="presale-wrp" style="padding-bottom: 16px">
                    <el-checkbox-group v-model="formData.timeSpecList">
                      <el-checkbox
                        v-for="item in timeSpecLabels"
                        :key="item.timeType"
                        :label="item.timeType"
                        > {{ item.timeDesc }}</el-checkbox>
                    </el-checkbox-group>
                    <p style="margin-bottom: 0">发货时效计算起点：买家支付后开始计算发货时效（例：买家支付后5天发货）</p>
                  </div>
                </el-form-item>
                <!-- 全款预售配置 -->
                <template v-if="formData.presellType === 1">
                        <el-form-item label="预售结束时间:" prop="presellEndTime">
                            <div class="presell-end-time">
                                <div class="radio-item">
                                    <el-radio v-model="formData.presellEndTimeType" :label="1">设置结束时间</el-radio>
                                    <el-date-picker
                                        v-if="formData.presellEndTimeType === 1"
                                        v-model="formData.presellEndTime"
                                        type="datetime"
                                        placeholder="请选择结束时间"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 220px; margin-left: 10px"
                                    ></el-date-picker>
                                </div>
                                <div class="radio-item" style="margin-top: 10px">
                                    <el-radio v-model="formData.presellEndTimeType" :label="2">无结束时间</el-radio>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item class="tips">
                            预售期间产生的订单须以预售发货时间进行发货；预售结束后，商品将自动下架
                            <br/>
                            最多支持设置距离当前为30天
                        </el-form-item>

                        <el-form-item v-if="allSaveDeliveryMode.length" label="预售发货时间:" prop="presellDeliveryType">
                            <div class="presell-delivery-time">
                                <el-select 
                                    v-model="formData.presellDeliveryType"
                                    placeholder="请选择发货时间"
                                    style="width: 160px"
                                >
                                <el-option 
                                    v-for="item in allSaveDeliveryMode"
                                    :key="item.value"
                                    :label="item.label" 
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                                <div class="delivery-days" style="display: inline-block; margin-left: 10px">
                                    <el-input-number 
                                        v-model="formData.presellDelay"
                                        :min="deliveryRules.minDays"
                                        :max="deliveryRules.maxDays"
                                        :precision="0"
                                        :step="1"
                                        style="width: 120px"
                                    ></el-input-number>
                                    <span class="tips" style="margin-left: 10px">天内发货</span>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item v-if="allSaveDeliveryMode.length" class="tips">
                            预售期间产生的订单须以预售发货时间进行发货；预售结束后，商品将自动下架
                            <br/>
                            预售期间商品发货时间以此限制为主，仅可设3 - 30天
                        </el-form-item>
                    </template>

                <el-form-item label="无理由退货服务:" prop="supplyDayReturnSelector">
                  <el-select v-model="formData.supplyDayReturnSelector" placeholder="请选择" width="300px">
                    <el-option v-for="item in supplyDayReturnList" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上架设置" prop="isOnshelf">
                  <el-radio-group v-model="formData.isOnshelf">
                    <el-radio :label="1">立即上架</el-radio>
                    <el-radio :label="2">放入草稿箱</el-radio>
                    <el-radio :label="0">下架</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </el-main>
          <el-footer>
            <div class="demo-drawer__footer">
              <el-button type="primary" @click="handleConfirm" v-if="shopId">{{extendProps.multiCheck?"确认":"确认铺货"}}</el-button>
              <el-button @click="handleClose">取 消</el-button>
            </div>
          </el-footer>
        </el-container>
      </el-container>
    </div>
  </el-drawer>
</template>
<script>
import { queryFxgItemShopList, addOrUpdateItemShop, getProductUpdateRule } from '@/api/prod/center';
import { getDistributionConfig } from '@servers/prod/conf/index.js';
import RULES from '../../components/DdianInfoForm/rules.js';
import AddSize from '../../components/DdianInfoForm/addSize.vue';
import _ from 'lodash';
import dayjs from 'dayjs';
import { saveBatchTempConfFxg } from '@/servers/prod/center/fxg.js';

export default {
  components: {
    AddSize,
  },
  props: {
    extendProps: {
      type: Object,
      default(){
        return {
          multiCheck: false,
          flowNumber:'',
        }
      }
    }
  },
  data() {
    const defaultForm = {
      sizeInfo: [], // 尺码信息
      presellType: 0, // 发货模式
      presellDeliveryType: 1, // 默认支付完成后发货
      deliveryDelayDay: 9999, // 承诺发货时间
      presellEndTime: '', // 预售结束时间
      presellDelay: 1, // 预售模式下结束后
      timeSpec: '', // 发货时效规格
      timeSpecList: [],
      supplyDayReturnSelector: '', // 售后规则信息
      isOnshelf: '', // 上架设置
      categoryIds: '',
      categoryLeafId: '',
      name: '',
      outerProductId: '',
      allSaveDeliveryMode: [],
    };

    return {
      ddianImg: require('@/assets/images/ddian.png'),
      drawerVisible: false,
      opts: {},
      deliveryModes: [],
      searchTxt: '',
      deliveryRules:{
        minDays: 3,
        maxDays: 30,
      },
      defaultForm: _.cloneDeep(defaultForm),
      formData: _.cloneDeep(defaultForm),
      cacheShopData: {},
      lastShopId: '',
      templateConfig: {
        templateId: '',
      },
      normalDelayOptions: [],
      timeSpecLabels: [],
      supplyDayReturnList: [],
      componentTemplateRule: {
          mustInput: false,
          sizeDimensionRange: {}
      }, // 尺码校验
      shopId: '',
      baseItemId: '',
      categoryId: '',
      allList: [],
      list: [],
      checkResultList: [],
      page: {
        pageNo: 1,
        pages: 1,
      },
      sizeTemplateList: [],
      confShelfState: '',
      noFinsheds: {},
      loadeds: {},
      rules: {},
      isLoadedProductUpdateRule: false,
      timeSkuPresellWithNormalRule:{},
      productPresellRule:{},
      stepRule: {},
    };
  },
  watch: {
    "formData.deliveryDelayDay"(){
      this.initRules()
    },
    "formData.timeSpecList"(){
      this.initRules()
    },
    stepRule: {
        // deep: true,
        // immediate: false,
        handler(v, oldVal) {
          // if(this.formData.presellType === 2 && v.support == true && (typeof this.formData.deliveryDelayDay) == 'number'){
          //   this.formData.deliveryDelayDay = [this.formData.deliveryDelayDay]
          // }
        }
    },
    'formData.presellType': {
          handler(newVal) {
              if (newVal === 1) { // 全款预售发货模式
                  this.$set(this.formData, 'presellDeliveryType', 1);
                  this.$set(this.formData, 'presellDelay', 3);
              }
              if (newVal === 2) {
                  // 混合模式：将 deliveryDelayDay 转为数组，避免 checkbox-group 退化返回 Boolean
                  if (typeof this.formData.deliveryDelayDay === 'number' && this.formData.deliveryDelayDay > 0) {
                      this.$set(this.formData, 'deliveryDelayDay', [this.formData.deliveryDelayDay]);
                  } else {
                      this.$set(this.formData, 'deliveryDelayDay', []);
                  }
              }
          },
      },
      'formData.presellEndTimeType': {
          handler(newVal) {
              if (newVal === 2) { // 无结束时间
                  this.formData.presellEndTime = ''
                  this.formData.presellDeliveryType = 1; // 强制设为支付完成后
              }
          }
      },
  },
  methods: {
    handleDeliveryDelayDayChange(values) {
        if (values.length > 1) {
            // 如果选中多个，只保留最后选中的值
            this.formData.deliveryDelayDay = [values[values.length - 1]];
        }
    },
    async method_open(opts = {}) {
      this.drawerVisible = true;
      this.opts = opts;
      await this.getAllCheckList();
      if (!this.list.length) return;
      const defaultItem = this.list[0];
      this.changeGoods(defaultItem);
    },
    async save() {
      if (!this.formData.baseItemId || this.formData.shopId <= 0) return false;
      return new Promise(async (resolve, reject) => {
        this.$refs.form.validate(async valid => {
          if (!valid) {
            this.$message.error('请完善表单');
            resolve(false);
            return false;
          }
          const formData = _.cloneDeep(this.formData)
          const addSizeData = this.$refs.addSizeRef ? await this.$refs.addSizeRef.method_getData() : false;
          if (!addSizeData) {
            resolve(false);
            return false;
          }

          const shopItem = {};
          Object.keys(this.defaultForm).forEach(key => {
            if (key === 'sizeInfo') {
              if (addSizeData.templateId) {
                shopItem[key] = JSON.stringify([addSizeData]);
              } else {
                shopItem[key] = null;
              }
            } else if (key === 'timeSpecList') {
              const newList = [];
              this.timeSpecLabels.forEach(item => {
                  if (formData.timeSpecList.includes(item.timeType)) {
                      newList.push(item.timeType);
                  }
              });
              // 发货时效需要按照指定顺序传参
              const preSaleTimeList = newList.sort((a, b) => a - b)
              if (formData.presellType === 2) {
                 // 新增发货时间处理逻辑
                if (this.stepRule.support === true && !this.timeSkuPresellWithNormalRule.support) {
                    // 新版本 处理发货时间
                    if (formData.deliveryDelayDay && formData.deliveryDelayDay > 0) {
                        // 如果已有值则保持不变
                        shopItem['timeSpecList'] = [String(formData.deliveryDelayDay), ...preSaleTimeList];
                    } else {
                        const timeList = [
                            String(formData.deliveryDelayDay),
                            ...(formData.timeSpecList || [])
                        ].filter(item => ![0, "0"].includes(item));
                        shopItem['timeSpecList'] = [...timeList];
                    }
                } else if (!this.stepRule.support && this.timeSkuPresellWithNormalRule.support === true) {
                    // 老版本 处理发货时间
                    if (formData.deliveryDelayDay && formData.deliveryDelayDay.length >0) {
                        shopItem.deliveryDelayDay = formData.deliveryDelayDay.join('')
                        shopItem['timeSpecList'] = [formData.deliveryDelayDay?.join(''), ...preSaleTimeList];
                    } else {
                        shopItem.deliveryDelayDay = 0
                        shopItem['timeSpecList'] = [...preSaleTimeList];
                        // 过滤掉数组中值为0的元素
                    }
                }
              } else {
                shopItem['timeSpecList'] = [...preSaleTimeList];
              }
            } else {
              shopItem[key] = formData[key];
            }
          });
          // console.log(params,addSizeData, this.$refs.addSizeRef, 'params---params');
          // resolve(false);
          // return;
          if(this.extendProps.multiCheck){
            const params = {
                companyId: this.$store.getters.userInfo.companyId,
                baseItemId: this.formData.baseItemId,
                shopId: this.formData.shopId,
                flowNumber: this.extendProps.flowNumber,
                ...shopItem,
            }
            const res = await saveBatchTempConfFxg(params)
            if (res.result === 1) {
              this.$message.success('保存成功')
            } else {
              this.$message.error(res.message)
            }
          } else {
          const params = [
            {
              id: this.formData.id,
              companyId: this.$store.getters.userInfo.companyId,
              baseItemId: this.formData.baseItemId,
              shopId: this.formData.shopId,
              shopItem: JSON.stringify(shopItem),
            },
          ];
          const res = await addOrUpdateItemShop(params);
          if (res.result === 1) {
            const { baseItemId, shopId } = this.formData;
            const shopIndex = this.noFinsheds[baseItemId].findIndex(shopList => shopList.includes(String(shopId)));
            if (shopIndex > -1) {
              this.noFinsheds[baseItemId].splice(shopIndex, 1);
            }
            }
          }
          resolve(true);
        });
      });
    },
    async handleConfirm() {
      const saveRes = await this.save();
      if (!saveRes) return;
      await this.getAllCheckList();
      const isMatch = Object.values(this.noFinsheds).some(list => list.length);
      if (isMatch) {
        this.$message.error('您还有店铺发布信息未完善！');
        return false;
      } else {
        this.handleClose();
        this.$emit('confirm');
      }
    },
    selectMenu(baseItemId) {
      const curGoods = this.list.find(item => item.baseItemId === baseItemId);
      this.changeGoods(curGoods);
    },
    changeGoods(item) {
      if (!item) return;
      this.checkResultList = item.shopItems;
      this.baseItemId = item.baseItemId;
      this.categoryId = item.categoryId;
      this.changeShop(this.checkResultList[0]);
    },

    async changeShop(item) {
      const saveRes = await this.save();
      if(this.lastShopId) {
        const cacheForm = _.cloneDeep(this.formData)
        const sizeData = this.$refs.addSizeRef.method_getNoValidData() 
        this.cacheShopData[this.lastShopId] = {
          ...cacheForm,
          sizeInfo: [sizeData]
        }
      }
      this.shopId = String(item.shopId);
      this.lastShopId = this.shopId;
      if (this.$refs.addSizeRef) {
        this.$refs.addSizeRef.shopId = this.shopId;
      }
      const concatId = `${item.baseItemId}_${item.shopId}`;
      let curItem = _.cloneDeep(item);
      if(this.cacheShopData[this.shopId]) {
        curItem = this.cacheShopData[this.shopId];
      } else if (this.loadeds[concatId]) {
        const { list } = await this.getPostCheckShopList({ baseItemIds: [item.baseItemId], shopIds: [item.shopId] });
        curItem = list[0]?.shopItems[0] || {};
      }
      this.$set(this.loadeds, concatId, true);
      // 转换时间格式，后端数据可能是字符串，也可能是时间戳
      curItem.presellEndTime = curItem.presellEndTime ? dayjs(curItem.presellEndTime).format('YYYY-MM-DD HH:mm:ss') : '';
      if(curItem.presellEndTime){
          // 存在结束时间
          curItem.presellEndTimeType = 1
      } else {
          // 无结束时间
          curItem.presellEndTimeType = 2
      }
      // 处理 deliveryDelayDay 的数据类型 
      // if (curItem.presellType === 2 && this.stepRule.support && (typeof curItem.deliveryDelayDay) != 'object') {
      //   curItem.deliveryDelayDay = curItem.deliveryDelayDay ? [curItem.deliveryDelayDay] : [];
      // }
      this.formData = { ..._.cloneDeep(this.defaultForm), ...curItem };
      // 上架设置
      this.formData.isOnshelf = this.formData.isOnshelf || this.formData.isOnshelf === 0 ? this.formData.isOnshelf : this.confShelfState;
      await this.getDayRetrunList();
      this.$nextTick(() => {
        this.$refs.form?.validate();
      });
    },
    async changeShopTab() {
      const curShop = this.list.find(item => item.baseItemId == this.baseItemId).shopItems.find(shopItem => shopItem.shopId == this.shopId);
      await this.changeShop(curShop);
    },
    async getPostCheckShopList(opts) {
      const { baseItemIds, shopIds } = opts;
      const res = await queryFxgItemShopList({
        baseItemIdList: baseItemIds,
        shopIdList: shopIds,
        companyId: this.$store.getters.userInfo.companyId,
      });
      const baseItemMaps = {},
        noFinsheds = {},
        data = res.data || [],
        noFinshedList = [],
        finshedList = [];
      data.forEach(item => {
        if (item.checkResult) {
          finshedList.push(item);
        } else {
          noFinshedList.push(item);
        }
      });
      // 优先把校验有问题的放前面
      noFinshedList.concat(finshedList).forEach(item => {
        const baseItemId = item.baseItemId;
        const shopName = this.formatShopNameById(item.shopId);
        const parseShopItem = JSON.parse(item.shopItem);

        const shopItem = {
          ...item,
          ...parseShopItem,
          shopId: String(item.shopId),
          shopName,
          sizeInfo: parseShopItem.sizeInfo ? JSON.parse(parseShopItem.sizeInfo) : [],
        };
        if (baseItemMaps[baseItemId]) {
          baseItemMaps[baseItemId].shopItems.push(shopItem);
        } else {
          baseItemMaps[baseItemId] = {
            baseItemId,
            outerId: shopItem.outerProductId,
            title: shopItem.name,
            categoryId: shopItem.categoryLeafId,
            shopItems: [shopItem],
          };
        }
        noFinsheds[baseItemId] = noFinsheds[baseItemId] || [];
        if (!item.checkResult) {
          noFinsheds[baseItemId].push(String(item.shopId));
        }
      });
      const list = Object.values(baseItemMaps);
      return { noFinsheds, list };
    },
    async getAllCheckList() {
      const { noFinsheds, list } = await this.getPostCheckShopList(this.opts);
      this.$set(this, 'noFinsheds', noFinsheds);

      this.allList = list;
      this.list = this.allList.slice(0, 100); // 默认取前100条，其余的可通过搜索查询
    },
    async searchClick() {
      const searchTxt = this.searchTxt.trim();
      let list = this.allList.slice(0, 100);
      if (searchTxt) {
        list = this.allList.filter(item => (item.outerId || '').includes(searchTxt) || (item.title || '').includes(searchTxt));
      }
      this.list = list;
      if (this.list.length) {
        this.changeGoods(this.list[0]);
      } else {
        await this.save();
        this.baseItemId = '';
        this.shopId = '';
        this.formData = _.cloneDeep(this.defaultForm);
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data());
      this.drawerVisible = false;
      this.formData = _.cloneDeep(this.defaultForm);
      this.shopId = '';
      this.baseItemId = '';
      this.categoryId = '';
      this.allList = [];
      this.list = [];
      this.checkResultList = [];
      this.isLoadedProductUpdateRule = false;
      this.noFinsheds = {};
      this.loadeds = {};
      this.searchTxt = '';
    },
    async getDayRetrunList() {
      let res = await getProductUpdateRule({
        shopId: this.shopId,
        categoryId: this.categoryId,
      });
      this.componentTemplateRule = res.data?.componentTemplateRule || {};
      this.supplyDayReturnList = res.data?.afterSaleRule?.supplyDayReturnRule?.options || [];
      this.isLoadedProductUpdateRule = true;
      this.formData.supplyDayReturnSelector = this.formData.supplyDayReturnSelector || this.supplyDayReturnList[0]?.value || '';
      // 对发货模式/发货时效交互处理
      const { normalRule, stepRule,timeSkuPresellWithNormalRule, productPresellRule = {}, } = res.data.fulfillmentRule || {};
      const deliveryModes = [
        { label: '现货发货模式', value: 0 },
        {label: '全款预售发货模式', value: 1},
        { label: '现货预售混合模式', value: 2 },
      ];
      this.timeSkuPresellWithNormalRule = timeSkuPresellWithNormalRule
      this.stepRule = stepRule
      this.productPresellRule = productPresellRule
      this.deliveryModes = deliveryModes.filter(item => {
        if (item.label === '现货发货模式') {
          item.support = normalRule.support
          // return normalRule.support;
        }
        if (['现货预售混合模式'].includes(item.label)) {
          item.support = stepRule.support
          item.newSupport  = timeSkuPresellWithNormalRule.support
          stepRule.support == true? item.label = '现货预售混合模式（新）' : item.label = '现货预售混合模式'
          // return stepRule.support;
        }
        if (item.label === '全款预售发货模式') {
          item.support = productPresellRule.support
          // return stepRule.support;
        }
        return true;
      });
      let allSaveDeliveryMode  = [
          {label: '预售结束后', value: 0},
          {label: '支付完成后', value: 1}
      ]

      if(!productPresellRule.supportDeliveryAfterPay){
          allSaveDeliveryMode = allSaveDeliveryMode.filter(item=>!item.name == '支付完成后')
      }
      if(!productPresellRule.supportDeliveryAfterPresell){
          allSaveDeliveryMode = allSaveDeliveryMode.filter(item=>!item.name == '预售结束后')
      }
      this.allSaveDeliveryMode = _.cloneDeep(allSaveDeliveryMode)
      // 发货模式，需要判断一下当前选中的选项是否还存在
      const hasExist = this.deliveryModes.find(item => {
        return item.value === this.formData.presellType;
      });
      if (!hasExist) {
        this.formData.presellType = this.deliveryModes.length > 0 ? this.deliveryModes[0].value : '';
      }
    
        // 新增逻辑：当stepRule.support为false且timeSkuPresellWithNormalRule.support为false时
      if (!stepRule.support && !timeSkuPresellWithNormalRule.support) {
          //非新非老  设置为现货发货模式
          this.formData.presellType = 0;
          
          // 处理发货时间
          if (this.formData.deliveryDelayDay && this.formData.deliveryDelayDay > 0) {
              // 如果已有值则保持不变
          } else {
              // 如果没有值或值为0，设置为48小时
              this.formData.deliveryDelayDay = 2; // 48小时 = 2天
          }
          this.formData.timeSpecList = [this.formData.deliveryDelayDay]
      } else if(stepRule.support == true && !timeSkuPresellWithNormalRule.support && this.formData.presellType == 2){
       // 新 处理发货时间
          if (this.formData.deliveryDelayDay && this.formData.deliveryDelayDay > 0) {
              // 如果已有值则保持不变
          } else {
              // 如果没有值或值为0，设置为48小时
              this.formData.deliveryDelayDay = 2; // 48小时 = 2天
               // 过滤掉数组中值为0的元素
              const timeList = [ 
                this.formData.deliveryDelayDay, 
                ...(this.formData.timeSpecList || [])
              ].filter(item =>  ![0,"0"].includes(item));
              this.formData.timeSpecList = [...timeList]
          }
      } else if(!stepRule.support && timeSkuPresellWithNormalRule.support == true && this.formData.presellType == 2){
         //老版本 处理发货时间
         if (this.formData.deliveryDelayDay && this.formData.deliveryDelayDay > 0) {
              // 如果已有值则保持不变
              this.formData.deliveryDelayDay = [this.formData.deliveryDelayDay]
          } else {
              this.formData.deliveryDelayDay = []; 
               // 过滤掉数组中值为0的元素
          }
      }
      if(this.productPresellRule.support == false && this.formData.presellType == 1){
        this.formData.presellType = 0
      }
      // if (normalRule.support) {
        const delayMaps = {
          9999: '当日发',
          1: '次日发',
          2: '48小时内发货',
        };

        this.normalDelayOptions = normalRule.delayOptions.map(val => {
          return { value: val, label: delayMaps[val] };
        });
      // }
      const defaultMultiTimes = [
          { timeDesc: '3天内', timeType: 3 },
          { timeDesc: '4天内', timeType: 4 },
          { timeDesc: '5天内', timeType: 5 },
          { timeDesc: '6天内', timeType: 6 },
          { timeDesc: '7天内', timeType: 7 },
          { timeDesc: '8天内', timeType: 8 },
          { timeDesc: '9天内', timeType: 9 },
          { timeDesc: '10天内', timeType: 10 },
          { timeDesc: '15天内', timeType: 15 },
          // { timeDesc: '20天内', timeType: 20 },
          // { timeDesc: '25天内', timeType: 25 },
      ];
      // if (stepRule.support) {
          this.timeSpecLabels = (stepRule.multiTimes || defaultMultiTimes).filter(item => {
              item.timeType = item.timeType + ''
              return true
          });
      // }
    },
    formatShopNameById(shopId) {
      return (this.$store.getters.shops_getById(shopId) || {}).title;
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: 'TouTiaoFXG' });
      this.confShelfState = res?.shelfState || 1;
    },
    initRules() {
      const rulesProps = ['deliveryDelayDay', 'timeSpecList', 'presellEndTime', 'presellDelay', 'supplyDayReturnSelector', 'isOnshelf'];
      const rules = {};
      const dyRules = RULES(this);

      rulesProps.map(prop => {
        if (dyRules[prop]) {
          rules[prop] = dyRules[prop];
        }
      });
      rules.presellType = [{ required: true, message: '请选择发货模式' }];
      this.$set(this, 'rules', rules);
    },
  },
  mounted() {
    this.initRules();
    this.getConf();
  },
};
</script>

<style lang="scss" scoped>
.m-drawer {
  ::v-deep .left-aside {
    height: calc(100vh - 100px);
    overflow: auto;
    padding: 0px 15px;
    border-right: 1px solid #eee;
    .el-menu {
      border: none;
    }
    .el-menu-item {
      padding: 10px !important;
      margin: 5px;
      height: auto;
      white-space: break-spaces;
      word-break: break-word;
      cursor: pointer;
      border-radius: 10px;
      box-sizing: border-box;
      position: relative;
    }
    .el-menu-item.is-active {
      border: 1px solid #396cf3;
    }
  }
  ::v-deep .el-drawer__header {
    font-size: 18px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  .right-main {
    padding: 0px 20px;
    overflow: hidden;
  }
  .form-content {
    height: calc(100vh - 160px);
    overflow: auto;
  }
  .drawer-content {
    .title {
      font-size: 12px;
      margin-bottom: 20px;
    }
    .search-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .wraning-wrap {
      position: absolute;
      top: 2px;
      right: 2px;
      font-size: 14px;
      color: #f56c6c;
    }
    .slot-title {
      p {
        margin-block: 0;
        line-height: 20px;
        overflow: hidden;
      }
      p.title {
        font-weight: 700;
      }
    }
  }
  .demo-drawer__footer {
    position: fixed;
    bottom: 10px;
    width: 100%;
    padding: 10px;
    background: #fff;
    z-index: 100;
  }
  // .item {
  //   padding-bottom: 20px;
  // }
  .presell-end-time {
    .radio-item {
      display: flex;
      align-items: center;
    }
  }

  .presell-delivery-time {
    display: flex;
    align-items: center;
  }

}
</style>
